import React from 'react';
import { Link } from 'react-router-dom';
import { useTenant } from './contexts/TenantContext';

function MyPlan() {
  var { tenant, businessName } = useTenant();
  var currentPlan = tenant?.plan || 'trial';
  var isTrial = currentPlan === 'trial';
  var color = isTrial ? '#f59e0b' : '#ff6b2b';
  var label = isTrial ? 'Free Trial' : 'Founding Member';

  var trialDaysLeft = 0;
  if (tenant?.trial_ends_at) {
    var diff = new Date(tenant.trial_ends_at) - new Date();
    trialDaysLeft = Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
  }

  var features = [
    { name: 'Dashboard', icon: '\u{1F4CA}', path: '/app' },
    { name: 'Booking Calendar', icon: '\u{1F4C5}', path: '/app/bookings' },
    { name: 'Online Booking Page', icon: '\u{1F310}', path: null },
    { name: 'Customer CRM', icon: '\u{1F465}', path: '/app/customers' },
    { name: 'Staff Management', icon: '\u{1F454}', path: '/app/staff' },
    { name: 'Staff Calendar', icon: '\u{1F5D3}', path: '/app/schedule' },
    { name: 'Quick Checkout', icon: '\u{1F4B5}', path: '/app/checkout' },
    { name: 'Automated Reminders', icon: '\u{1F514}', path: '/app/reminders' },
    { name: 'Reports & Analytics', icon: '\u{1F4CA}', path: '/app/reports' },
    { name: 'Business Website', icon: '\u{1F3A8}', path: '/app/site' },
    { name: 'CSV Import', icon: '\u{1F4CB}', path: '/app/import' },
    { name: 'Employee Portal (PIN)', icon: '\u{1F510}', path: null },
    { name: 'Commission Tracking', icon: '\u{1F4B5}', path: '/app/commissions' },
    { name: 'Memberships', icon: '\u{1F504}', path: '/app/memberships' },
    { name: 'Gift Cards', icon: '\u{1F381}', path: '/app/gift-cards' },
    { name: 'Inventory Management', icon: '\u{1F4E6}', path: '/app/inventory' },
    { name: 'Work Orders', icon: '\u{1F527}', path: '/app/work-orders' },
    { name: 'Estimates & Invoicing', icon: '\u{1F4C4}', path: '/app/estimates' },
    { name: 'Vehicle Profiles', icon: '\u{1F697}', path: '/app/vehicles' },
    { name: 'SMS Marketing', icon: '\u{1F4F1}', path: '/app/sms-campaigns' },
    { name: 'Waitlist', icon: '\u{1F4CB}', path: '/app/waitlist' },
    { name: 'Notification Log', icon: '\u{1F4E8}', path: '/app/notifications' },
    { name: 'Shop Queue TV', icon: '\u{1F4FA}', path: null },
    { name: 'Customer Portal', icon: '\u{1F50D}', path: null },
  ];

  return (
    <div style={{ padding: '32px', maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ background: 'linear-gradient(135deg, ' + color + '15, ' + color + '05)', borderRadius: '20px', padding: '32px', border: '1px solid ' + color + '30', marginBottom: '28px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
              <span style={{ padding: '4px 14px', borderRadius: '20px', fontSize: '13px', fontWeight: '700', background: color + '20', color: color }}>{label}</span>
              {isTrial && trialDaysLeft > 0 && <span style={{ color: '#888', fontSize: '13px' }}>{trialDaysLeft} days left</span>}
            </div>
            <h1 style={{ color: '#fff', fontSize: '26px', fontWeight: '800', margin: '0 0 4px', letterSpacing: '-0.5px' }}>{businessName}</h1>
            <p style={{ color: '#888', fontSize: '14px', margin: 0 }}>
              {isTrial ? 'All features unlocked during your trial' : 'All features included \u00B7 $199/mo \u00B7 Locked in forever'}
            </p>
          </div>
          <Link to="/app/billing" style={{
            padding: '12px 24px', background: 'linear-gradient(135deg, #ff6b2b, #ffab40)',
            borderRadius: '10px', color: '#fff', fontSize: '14px', fontWeight: '700', textDecoration: 'none',
          }}>{isTrial ? 'Subscribe \u2014 $199/mo' : 'Manage Billing'}</Link>
        </div>
      </div>

      <div style={{ background: '#12121f', borderRadius: '16px', padding: '28px', border: '2px solid #ff6b2b30', marginBottom: '28px', textAlign: 'center' }}>
        <div style={{ fontSize: '11px', fontWeight: '700', color: '#ff6b2b', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '8px' }}>Founding Member</div>
        <div style={{ color: '#fff', fontSize: '48px', fontWeight: '800', lineHeight: 1 }}>$199<span style={{ fontSize: '18px', color: '#666' }}>/mo</span></div>
        <p style={{ color: '#888', fontSize: '13px', margin: '12px 0 0' }}>Every feature \u00B7 Unlimited staff \u00B7 3,000 SMS/mo \u00B7 No contracts</p>
        {isTrial && <p style={{ color: '#f59e0b', fontSize: '12px', fontWeight: '700', marginTop: '8px' }}>Price locks in at $199/mo forever when you subscribe. Goes to $299/mo after founding slots fill.</p>}
      </div>

      <h2 style={{ color: '#fff', fontSize: '18px', fontWeight: '700', margin: '0 0 16px' }}>Everything Included</h2>

      <div style={{ display: 'grid', gap: '8px' }}>
        {features.map(function(f, i) {
          return (
            <div key={i} style={{
              background: '#12121f', borderRadius: '12px', padding: '16px 20px',
              border: '1px solid #1e1e35', display: 'flex', alignItems: 'center', gap: '14px',
            }}>
              <span style={{ fontSize: '20px', width: '28px', textAlign: 'center' }}>{f.icon}</span>
              <span style={{ flex: 1, color: '#fff', fontSize: '14px', fontWeight: '600' }}>{f.name}</span>
              {f.path ? (
                <Link to={f.path} style={{ padding: '6px 14px', borderRadius: '8px', fontSize: '12px', fontWeight: '700', background: '#00b89420', color: '#00b894', textDecoration: 'none' }}>Open</Link>
              ) : (
                <span style={{ padding: '6px 14px', borderRadius: '8px', fontSize: '12px', fontWeight: '700', background: '#00b89420', color: '#00b894' }}>{'\u2713'} Included</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MyPlan;
